import type { routes } from '~/providers/RouterProvider/router.routes';
import type { Params } from '~/providers/RouterProvider/router.types';

import { clientsQueryOptions } from '~/api/clients';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';

export const loader = async ({ params }: { params: Params<typeof routes.editContact> }) => {
  const clients = await queryClient.query({ ...clientsQueryOptions, staleTime: 'static' });

  const client = clients.find((client) => client.id === Number(params.clientId) && !client.deleted) ?? null;
  const contact = client?.contacts.find((contact) => contact.id === Number(params.contactId) && !contact.deleted) ?? null;

  return { client, contact };
};
